import { render, staticRenderFns } from "./AppSidebar.vue?vue&type=template&id=1a07bcb5&scoped=true"
import script from "./AppSidebar.vue?vue&type=script&lang=ts"
export * from "./AppSidebar.vue?vue&type=script&lang=ts"
import style0 from "./AppSidebar.vue?vue&type=style&index=0&id=1a07bcb5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a07bcb5",
  null
  
)

export default component.exports